export interface ScoresResponse {
    data: ScoresData[];
}

export interface ScoresData {
    user_id: string;
    global_score: number;
    global_level: Level;
    global_level_max_score: number;
    global_next_level: Level;
    global_max_score: number;
    progresses: ScoreProgress[];
}

export interface ScoreProgress {
    module_id: string;
    score: number;
    is_validated: boolean;
    validated_leagues: Level[];
    next_level: Level | null;
}

export enum Level {
    bois = 'bois',
    bronze = 'bronze',
    argent = 'argent',
    or = 'or',
    diamant = 'diamant',
}
